import { ReportGenerationSection } from "@/screens/ReportGenerationSection/ReportGenerationSection";

export const Generate = (): JSX.Element => {
  return (
    <div className="page-shell">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground mb-2 page-main-heading">Generate Reports</h1>
        </div>
      </div>
      <ReportGenerationSection />
    </div>
    // <AppLayout
    //   headerVariant="with-notifications"
    //   breadcrumbTitle="Reports"
    //   minWidth="min-w-[1440px]"
    //   minHeight="min-h-[999px]"
    // >
    //   <HeaderSection />
    //   <ReportGenerationSection />
    // </AppLayout>
  );
};

